export function normalizationData(object, options = {}) {
  const data = {};

  Object.assign(data, object);
  Object.keys(options).forEach((field) => {
    const f = options[field];

    data[field] = f(data[field]);
  });

  return data;
}
